import {EMPLOYEE_API_AGENDA} from '@/library/modules/employee/api';
import store from '../store';

function hasModule(module: string)
{
    return !!store.state.layoutData.modules.filter((i) => i.resource === module).length;
}

function hasApp()
{
    return !!store.state.layoutData.hasApp;
}

function hasTerminalApp()
{
    return !!store.state.layoutData.hasTerminalApp;
}

function useTerminalApp()
{
    return !!store.state.layoutData.useTerminalApp;
}

function timeTrackerAppOnly()
{
    return !!store.state.layoutData.employee_configuration?.time_tracker_app_only || false;
}

function getRightsBy()
{
    return store.state.layoutData.rightsBy;
}

function isRightsByEmployee()
{
    return getRightsBy().includes('employee');
}

function isRightsByUser()
{
    return getRightsBy().includes('user');
}

function hasAgendaAPI()
{
    return !!store.state.layoutData.employee_configuration?.employee_apis.includes(EMPLOYEE_API_AGENDA);
}

function isAgendaApiEnabled()
{
    return hasAgendaAPI() && store.state.layoutData?.employee_apis_enabled?.includes(EMPLOYEE_API_AGENDA);
}

export {
    hasModule,
    hasApp,
    hasTerminalApp,
    useTerminalApp,
    useTimeTrackerApp,
    timeTrackerAppOnly,
    getRightsBy,
    isRightsByEmployee,
    isRightsByUser,
    hasAgendaAPI,
    isAgendaApiEnabled,
};